<template>
  <IconSolid :icon="icon" :class="[{ 'text-success-500': modelValue, 'text-red-500': !modelValue }]" />
</template>

<script setup>
const props = defineProps({
  modelValue: Boolean,
  icon: {
    type: String,
    default: 'fa-circle',
  },
})
</script>
